module.exports = __webpack_public_path__ + "img/quicksplain_white.7be21e04.svg";